import React from 'react';
import { Navigate } from 'react-router-dom';

const PrivateRouteAdmin = ({ children }) => {
  const token = localStorage.getItem('token');
  const user = JSON.parse(localStorage.getItem('user'));

  if (!token || !user || user.role !== 'ADMIN') {
    return <Navigate to="/login" />;
  }

  return children;
};

export default PrivateRouteAdmin;
